module.exports = __webpack_public_path__ + "static/media/JackWilliams.285a82fe.jpg";